import { ChangeDetectionStrategy, Component, DestroyRef, input, inject, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { EmployeeService } from '@coin/shared/auth/data-access';
import { UserState } from '@coin/shared/auth/feature';
import {
  EmployeesEmployeesEmployeeDirectModel,
  EmployeesEmployeesEmployeeDirectModelMercerStandingValidationStateEnum
} from '@coin/shared/core/util-models';
import { Store } from '@ngxs/store';
import { EmployeePictureComponent, V2DualPillComponent } from '@coin/shared/core/ui-storybook';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-direct-item-overview',
  templateUrl: './direct-item-overview.component.html',
  styleUrls: ['./direct-item-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmployeePictureComponent, V2DualPillComponent, TranslatePipe],
  host: {
    '(keydown.code.Enter)': 'goToDocumentCenter()',
    '(keydown.code.Space)': 'goToDocumentCenter()'
  }
})
export class DirectItemOverviewComponent {
  private router = inject(Router);
  private store = inject(Store);
  private employeeService = inject(EmployeeService);
  private destroyRef = inject(DestroyRef);

  direct = input(undefined, { transform: (e: EmployeesEmployeesEmployeeDirectModel) => structuredClone(e) });

  isOpen = computed(
    () =>
      this.direct()?.mercerStandingValidationState &&
      ![
        EmployeesEmployeesEmployeeDirectModelMercerStandingValidationStateEnum.Approved,
        EmployeesEmployeesEmployeeDirectModelMercerStandingValidationStateEnum.Rejected
      ].includes(this.direct().mercerStandingValidationState)
  );

  readonly OpenStateName =
    `mercer-standing.state.${EmployeesEmployeesEmployeeDirectModelMercerStandingValidationStateEnum.Open}`.toLowerCase();

  goToDocumentCenter(): void {
    this.employeeService
      .getEmployeeDetails(this.store.selectSnapshot(UserState?.user)?.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(employee => {
        this.router.navigate(['/employee-detail-overview'], {
          queryParams: {
            receiverId: this.direct().id,
            managerId: employee?.id
          }
        });
      });
  }
}
